<form [formGroup]="dynamicForm" novalidate autocomplete="off">
    <table *ngIf="!isMobile" class="table table-striped">
        <thead>
            <tr>
                <th class="include-column">Include</th>
                <th *ngFor="let headElem of elements" [ngClass]="{ required: headElem.required }">
                    {{ headElem.label }}
                </th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let entry of dynamicForm.controls; let entryIdx = index">
                <td class="include-column">
                    <input
                        type="checkbox"
                        id="check_{{ entryIdx }}"
                        [formControl]="entry.controls.selected"
                        class="ch-checkbox"
                    />
                    <label for="check_{{ entryIdx }}" class="ch-checkbox-label"></label>
                </td>
                <td *ngFor="let elem of entries[entryIdx].fields">
                    <ng-container
                        *ngTemplateOutlet="elemControl; context: { elem: elem, entry: entry, entryIdx: entryIdx }"
                    >
                    </ng-container>
                </td>
            </tr>
        </tbody>
    </table>
    <div *ngIf="isMobile" class="mobile-form">
        <div class="mobile-form__entry" *ngFor="let entry of dynamicForm.controls; let entryIdx = index">
            <div class="form-group include-group">
                <cm-switch [formControl]="entry.controls.selected"></cm-switch>
                <label class="form-label form-label--bold">Include</label>
            </div>
            <div *ngFor="let elem of entries[entryIdx].fields" class="form-group">
                <label [ngClass]="{ required: elem.required }">{{ elem.label }}</label>
                <ng-container
                    *ngTemplateOutlet="elemControl; context: { elem: elem, entry: entry, entryIdx: entryIdx }"
                >
                </ng-container>
            </div>
        </div>
    </div>
</form>

<ng-template let-elem="elem" let-entry="entry" let-entryIdx="entryIdx" #elemControl>
    <ng-container *cmLet="entry.controls.elements.controls[elem.id] as elementControl">
        <ng-container
            *cmLet="
                showErrors &&
                !elementControl.disabled &&
                (elementControl.errors || (elem.error && elementControl.pristine)) as showControlError
            "
            [ngSwitch]="elem.type.id"
            [formGroup]="entry.controls.elements"
        >
            <input
                *ngSwitchCase="FIELD_TYPES.EMAIL"
                type="email"
                formControlName="{{ elem.id }}"
                required="{{ elem.required }}"
                class="form-control ch-input"
                [ngClass]="{ 'is-invalid': showControlError }"
            />

            <cm-radio-group
                *ngSwitchCase="FIELD_TYPES.RADIO"
                formControlName="{{ elem.id }}"
                [options]="elem.elementOptions"
                [ngClass]="{ 'is-invalid': showControlError }"
                [required]="elem.required"
            >
            </cm-radio-group>

            <cm-checkbox-group
                *ngSwitchCase="FIELD_TYPES.CHECKBOX"
                formControlName="{{ elem.id }}"
                [options]="elem.elementOptions"
                [ngClass]="{ 'is-invalid': showControlError }"
                [required]="elem.required"
            >
            </cm-checkbox-group>

            <cm-select
                *ngSwitchCase="FIELD_TYPES.SELECT"
                [options]="elem.elementOptions"
                [ngClass]="{ 'is-invalid': showControlError }"
                formControlName="{{ elem.id }}"
            >
            </cm-select>

            <div *ngSwitchCase="FIELD_TYPES.NUMBER">
                <cm-number-input
                    *ngIf="elem.label === 'Hours'"
                    [maskConfig]="numberMaskConfig"
                    [ngClass]="{ 'is-invalid': showControlError }"
                    formControlName="{{ elem.id }}"
                >
                </cm-number-input>
                <cm-number-input
                    *ngIf="elem.label !== 'Hours'"
                    [ngClass]="{ 'is-invalid': showControlError }"
                    formControlName="{{ elem.id }}"
                >
                </cm-number-input>
            </div>

            <cm-datepicker
                *ngSwitchCase="FIELD_TYPES.DATE"
                class="ch-datepicker"
                [useDeprecatedDateOutputFormat]="true"
                formControlName="{{ elem.id }}"
                [ngClass]="{ 'is-invalid': showControlError }"
            >
            </cm-datepicker>

            <input
                *ngSwitchCase="FIELD_TYPES.TEXT"
                formControlName="{{ elem.id }}"
                class="form-control ch-input"
                [ngClass]="{ 'is-invalid': showControlError }"
            />

            <input
                *ngSwitchDefault
                formControlName="{{ elem.id }}"
                class="form-control ch-input"
                [ngClass]="{ 'is-invalid': showControlError }"
            />

            <p *ngIf="showControlError" class="required-field-hint">
                <ng-container *ngIf="elementControl.errors; else uploadFormatError">
                    <ng-container *ngIf="elementControl.errors.required"> Required field </ng-container>
                    <ng-container *ngIf="elementControl.errors.email"> Please enter the valid email </ng-container>
                </ng-container>
                <ng-template #uploadFormatError> Invalid uploaded value </ng-template>
            </p>
        </ng-container>
    </ng-container>
</ng-template>
